export enum TOASTS {
  ERROR = "ERROR",
  INFO = "INFO",
  LOADING = "LOADING",
  DISMISS_ALL = "DISMISS_ALL",
  LOGIN_ERROR = "LOGIN_ERROR",
}

